<template>
    <div class="m-8 mx-auto band max-w-site lg:m-16 xl:m-20">
      <div class="px-4 py-2 mx-auto band__content max-w-content-large">
        <div class="flex flex-wrap justify-between lg:flex-no-wrap">
            {{GetTransactionStatus}}
            <!--<ReservationSummary :reservation="transactionReservation" :step="step" v-on:next="next()" />-->
        </div>
      </div>
    </div>
</template>

<script>
    import CaagApi from '@/mixins/CaagApi'
    import { mapGetters } from 'vuex'
    import ReservationHelper from "@/mixins/ReservationHelper"

    export default {
        name: 'ReservationCheck',
        mixins: [ReservationHelper, CaagApi],
        components: {
        },
        props: {
            token: String
        },
        data: () => ({
            thankYouUrl: null,
            transactionResult: null,
        }),
        watch: {
            transactionResult: function(val) {
                if ( val.status === 'paid' ) {
                    let products = [{
                        'name': this.CarName,
                        'price': this.CarPriceInclDiscountAndAdditionalCharges,
                        'quantity': 1
                    }]

                    this.$gtag.purchase({
                        'transaction_id': this.reservation.id,
                        'value': this.TotalPrice,
                        'tax': this.TotalTax,
                        'shipping': 0,
                        'items': products
                    })

                    this.$store.commit('reset')
                    this.$store.commit('step', 1)
                    if (this.thankYouUrl) {
                        window.location = this.thankYouUrl
                    }                        
                }
                else {
                    this.$store.commit('step', 5)
                }
            }
        },
        computed: {
            ...mapGetters([
                'step',
                'reservation',
                'dates'
            ]),
            GetTransactionStatus: function() {
                if ( this.transactionResult ) {
                    if ( this.transactionResult.item_id ) {
                        return this.$t("paymenttransaction."+  this.transactionResult.status, { number: this.transactionResult.item_id })
                    }
                    else {
                        return this.$t("paymenttransaction."+  this.transactionResult.status)
                    }
                }
                else {
                    return this.$t("paymenttransaction.search")
                }
            }
        },
        created() {
            if ( window.reservationConfiguration && window.reservationConfiguration.thankYouUrl ) {
                this.thankYouUrl = window.reservationConfiguration.thankYouUrl
            }   
        },

        mounted() {
            this.checkPaymentTransaction(this.token)
        },
    }
</script>
